import { Box, Link } from '@amzn/awsui-components-console';
import React from 'react';

export const Slackbox = () => (
  <Box variant='p'>
    For help, view the{' '}
    <Link
      target='_blank'
      href={
        'https://alpha.www.docs.aws.a2z.com/fusion/latest/userguide/flc-using-flc.html'
      }
    >
      Fusion User Guide
    </Link>{' '}
    and{' '}
    <Link
      target='_blank'
      href='https://w.amazon.com/bin/view/AWSDocs/testing-and-publishing/api-docs/'
    >
      API Reference Wiki
    </Link>{' '}
    or ask in the the{' '}
    <Link
      target='_blank'
      href='https://amzn-aws.slack.com/archives/G01B6BT0NF8'
    >
      #tcx-conferences Slack channel
    </Link>
    .
  </Box>
);
